import { useFetch } from "use-http";
import { interpolate } from "react-arc";
import config from "../../../../config/config";

function useBoardAddContents({ token, data }) {
  const url = interpolate(config.boards.contents, data);
  const { post, response, loading, error } = useFetch(url, {
    cacheLife: 0,
    cachePolicy: "no-cache",
    headers: {
      "Content-Type": "application/json",
      "X-Auth-Token": token,
    },
  });

  const handleAdd = ({ id, parent = null }) => {
    return post({
      board_id: data.id,
      menu_id: id,
      parent_id: parent,
    });
  };

  return [error, loading, response, handleAdd];
}

export default useBoardAddContents;
